import React, { createContext, useContext, useState } from 'react'
import PropTypes from 'prop-types'

const CurrentItemContext = createContext({ item: null, setItem: () => {} })

export function CurrentItemProvider({ children }) {
  const [item, setItem] = useState(null)

  return (
    <CurrentItemContext.Provider value={{ item, setItem }}>
      {children}
    </CurrentItemContext.Provider>
  )
}

CurrentItemProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export function useCurrentItem() {
  return useContext(CurrentItemContext)
}
